import { Stack, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import { AboutVersionLink, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import Copyright from "../About/Copyright";

function SettingsFooter() {
  const { version, os } = useConfigContext();

  return (
    <Stack mx={2} gap={1} alignItems="flex-start">
      <Copyright />
      <Typography color="text.secondary" variant="ui-2xs">
        <Trans>version: {version}</Trans>
      </Typography>
      {!!os && (
        <Typography color="text.secondary" variant="ui-2xs">
          <Trans>os: {os}</Trans>
        </Typography>
      )}
      <AboutVersionLink />
    </Stack>
  );
}

export default SettingsFooter;
